import AppDataService from "./AppDataService";

class BundleOrderService {
  async createBundleOrder(payload) {
    try {
      const response = await AppDataService.post(
        `visit-note/bundle-order`,
        payload
      );
      return response;
    } catch (error) {
      console.error("Error creating bundle order:", error);
      throw error;
    }
  }
}

export default new BundleOrderService();
